import { styled, keyframes } from "styled-components";
import { Link } from "react-router-dom";
import logoImg from "../images/common/toplogo_w.png";
import ftIcon1 from "../images/common/ft_icon1.png";
import ftIcon1hv from "../images/common/ft_icon1_hv.png";
import ftIcon2 from "../images/common/ft_icon2.png";
import ftIcon2hv from "../images/common/ft_icon2_hv.png";
import ftIcon3 from "../images/common/ft_icon3.png";
import ftIcon3hv from "../images/common/ft_icon3_hv.png";
import ftIcon4 from "../images/common/ft_icon4.png";
import ftIcon4hv from "../images/common/ft_icon4_hv.png";
import MenuIcon from "@mui/icons-material/Menu";
import { SwipeableDrawer } from "@mui/material";
import Sidebar from "./SwipeBar";
import { useState } from "react";

function Header({ isScrolledDown }) {
  const [open, setOpen] = useState(false);
  const [isSubNavOpen, setIsSubNavOpen] = useState(false);
  const [openSidebar, setOpenSidebar] = useState(false);
  const [isListHover1, setIsListHover1] = useState(false);
  const [isListHover2, setIsListHover2] = useState(false);
  const [isListHover3, setIsListHover3] = useState(false);
  const [isListHover4, setIsListHover4] = useState(false);

  const toggleSidebar = (isOpen) => () => {
    setOpenSidebar(isOpen);
  };
  const handleSubNavOpen = () => {
    setIsSubNavOpen(true);
  };

  const handleSubNavClose = () => {
    setIsSubNavOpen(false);
  };

  // 스크롤 이벤트 핸들러
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // 부드러운 스크롤 효과
    });
  };

  // 마우스 오버 이벤트 핸들러
  const toggleFloatingIcon1 = (isOver) => () => {
    setIsListHover1(isOver)
  };
  const toggleFloatingIcon2 = (isOver) => () => {
    setIsListHover2(isOver)
  };
  const toggleFloatingIcon3 = (isOver) => () => {
    setIsListHover3(isOver)
  };
  const toggleFloatingIcon4 = (isOver) => () => {
    setIsListHover4(isOver)
  };

  return (
    <>
        <StyledHeader isScrolledDown={isScrolledDown}>
        <StyledDiv>
            <Link to="/" onClick={scrollToTop}>
            <div>
                <img src={logoImg} alt="logo" />
            </div>
            </Link>
        </StyledDiv>
        <StyledUl>
            <li>
            <StyledLink to="/" onClick={scrollToTop}>
                SKY 소개
            </StyledLink>
            </li>
            {/* <li>
            <StyledLink to="/two">two</StyledLink>
            </li> */}
            {/* <li>
            <StyledLink to="/skymedicaldoctor">의료진 소개</StyledLink>
            </li> */}
            {/* <li>
            <StyledLink to="/notice">공지사항</StyledLink>
            </li> */}
            <li>
            <StyledSubUl
                onMouseEnter={handleSubNavOpen}
                onMouseLeave={handleSubNavClose}
            >
                <StyledLink>전문진료센터안내</StyledLink>
                <StyledSubNav open={isSubNavOpen}>
                <li>
                    <StyledLink to="/subject/1">영상진단센터</StyledLink>
                </li>
                <li>
                    <StyledLink to="/subject/2">정형신경센터</StyledLink>
                </li>
                <li>
                    <StyledLink to="/subject/3">내과질환센터</StyledLink>
                </li>
                <li>
                    <StyledLink to="/subject/4">응급중환자센터</StyledLink>
                </li>
                <li>
                    <StyledLink to="/subject/5">피부호르몬센터</StyledLink>
                </li>
                <li>
                    <StyledLink to="/subject/6">안과센터</StyledLink>
                </li>
                {/* <li>
                    <StyledLink to="/subject/4">종양항암센터</StyledLink>
                </li>
                <li>
                    <StyledLink to="/subject/5">응급의학센터</StyledLink>
                </li> */}
                </StyledSubNav>
            </StyledSubUl>
            </li>
            {/* <li>
            <StyledLink to="https://kjw.skyamg.com" target="_blank">
                웹차트
            </StyledLink>
            </li> */}
        </StyledUl>
        <StyledIconWrappr onClick={toggleSidebar(true)}>
            <MenuIcon />
        </StyledIconWrappr>
        <Sidebar open={openSidebar} onClose={toggleSidebar(false)} />
        </StyledHeader>

        <StyleFloating className="floating">
            <StyledFloatingLink to="https://pf.kakao.com/_xlJJTn" target="_blank" onMouseEnter={toggleFloatingIcon3(true)} onMouseLeave={toggleFloatingIcon3(false)}>
                <img src={isListHover3 ? ftIcon3hv : ftIcon3} alt="상담하기"></img>
                <p class="">상담하기</p>
            </StyledFloatingLink>
            <StyledFloatingLink to="https://www.instagram.com/skyamg_wj" target="_blank" onMouseEnter={toggleFloatingIcon2(true)} onMouseLeave={toggleFloatingIcon2(false)}>
                <img src={isListHover2 ? ftIcon2hv : ftIcon2} alt="인스타그램"></img>
                <p class="">인스타그램</p>
            </StyledFloatingLink>
            <StyledFloatingLink to="https://naver.me/5ssBWO3D" target="_blank" onMouseEnter={toggleFloatingIcon4(true)} onMouseLeave={toggleFloatingIcon4(false)}>
                <img src={isListHover4 ? ftIcon4hv : ftIcon4} alt="오시는 길"></img>
                <p class="">오시는 길</p>
            </StyledFloatingLink>
            <StyledFloatingLink to="https://blog.naver.com/PostList.naver?blogId=skyamg_wj&from=postList&categoryNo=10&parentCategoryNo=10" target="_blank" onMouseEnter={toggleFloatingIcon1(true)} onMouseLeave={toggleFloatingIcon1(false)}>
                <img src={isListHover1 ? ftIcon1hv : ftIcon1} alt="치료케이스"></img>
                <p class="">치료케이스</p>
            </StyledFloatingLink>
        </StyleFloating>
    </>
  );
}
const StyleFloating = styled.div`
  position:fixed;
  top:50%;
  right:70px;
  transform:translateY(-50%);
  transition:all 0.3s;
  z-index:10;

  @media screen and (max-width: 1540px) {
    right: 20px;
  }
  @media screen and (max-width: 768px) {
    top: auto;
    bottom: 85px;
    right: 10px;
    transform: initial;
  }
  @media screen and (max-width: 640px) {
    bottom: 20px;
    right: 20px;
  }
    a+a{
        margin-top:10px;
    }
`;

const StyledFloatingLink = styled(Link)`
  display:block;
  width:100px;
  height:100px;
  padding:15px 0 18px;
  font-size:14px;
  font-weight:500;
  background:#fff;
  border:2px solid #3360ae;
  border-radius:50%;
  box-shadow: -1px 5px 10.56px 1.44px rgba(0, 0, 0, 0.17);
  transition:all 0.3s;
  display:flex;
  flex-direction:column;
  justify-content:flex-end;
  align-items:center;
  color:#000;
  text-decoration:none;

    @media screen and (max-width: 1540px) {
        width:80px;
        height:80px;
    }

    @media screen and (max-width: 640px) {
        width: 50px;
        height: 50px;
        padding : 0;
        justify-content: center;
    }


//   a {
//     margin-top:10px;
//     color:#000;
//     margin:0;
//     outline:none !important;

//     // @media screen and (max-width: 1540px) {
//     //   width:80px;height:80px;
//     // }

//     // @media screen and (max-width: 640px) {
//     //   width:50px;height:50px;
//     //   padding :0; justify-content:center;
//     // }

//   }
  p {
    font-size:14px;
    padding-top:5px;
    margin: 0;
    padding: 0;
    word-break: break-all;
    outline:none !important;

    @media screen and (max-width: 1540px) {
      font-size:12px;
    }

    @media screen and (max-width: 640px) {
      display:none;
    }
  }
  img {
    height:40px;
    transition:all 0.3s;
    vertical-align: middle;
    font-size: 1em;
    margin: 0;
    padding: 0;
    border: 0;
    outline:none !important;

    @media screen and (max-width: 1540px) {
      height:25px;
    }
  }
  &:hover{
    background:#3360ae;
  }
  &:hover p{
    color:#fff;
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const StyledHeader = styled.header`
  width: 100%;
  height: 8vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  z-index: 999;
  opacity: 0.9;
  background-color: ${({ isScrolledDown }) =>
    isScrolledDown ? "#000" : "none"};

  &:hover {
    background-color: #000;
    opacity: 0.9;

    > * {
      opacity: 1;
    }
  }

  /* padding: 0 300px; */
`;

const StyledDiv = styled.div`
  height: 100%;
  position: absolute;
  display: flex;
  align-items: center;
  left: 15px;

  div {
    max-width: 150px;
    height: 100%;
    display: flex;
    align-items: center;
    img {
      width: 100%;
      height: auto;
    }
  }
`;

const StyledUl = styled.ul`
  width: 100%;
  height: 100%;
  list-style-type: none;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 0 10vw;
  padding-top: 4px;

  li {
    margin-right: 5vw;
  }
  @media screen and (max-width: 690px) {
    display: none;
  }
`;

const StyledLink = styled(Link)`
  color: #fff;
  font-weight: 600;
  text-decoration: none;
  display: inline-block;
  position: relative;
  height: 8vh;
  display: flex;
  align-items: center;
  opacity: 1;

  width: 100%;
  margin: 0;
  padding: 0;
  font-size: 1.2em;
  color: #eee;
  line-height: 68px;

  &::before {
    content: ""; /* 가상 요소의 내용을 비워 둡니다 */
    position: absolute; /* 부모 요소인 .text를 기준으로 위치를 설정합니다 */
    bottom: 15px; /* 밑줄을 텍스트의 바닥에 맞춥니다 */
    left: 0; /* 시작 위치를 왼쪽 끝으로 설정합니다 */
    width: 0; /* 초기 밑줄의 너비는 0입니다 */
    height: 1px; /* 밑줄의 높이를 설정합니다 */
    background-color: #dabfa8; /* 밑줄의 색상을 설정합니다 */
    transition: width 0.3s ease; /* 밑줄의 너비가 변할 때의 애니메이션 효과를 설정합니다 */
  }

  &:hover {
    color: #dabfa8;
    opacity: 1;

    /* font-weight: bold; */
  }
  &:hover::before {
    width: 100%; /* 마우스를 올렸을 때 밑줄의 너비를 100%로 만듭니다 */
  }
`;

const StyledSubUl = styled.ul`
  list-style-type: none;
  position: relative;
  padding: 0;
  margin: 0;
  text-align: center;
`;

const StyledSubNav = styled.nav`
  list-style-type: none;
  position: fixed; /* 변경: fixed로 설정 */
  top: 8vh; /* 변경: 헤더 아래에 위치하도록 설정 */
  left: 0;
  width: 100%; /* 변경: 화면 너비에 맞게 확장 */
  background-color: #101010;
  display: ${({ open }) => (open ? "flex" : "none")};
  padding: 0;
  margin: 0;
  /* border-radius: 6px; */
  flex-direction: row; /* 변경: 가로로 배치하도록 수정 */
  justify-content: space-evenly; /* 변경: 수평 중앙 정렬 */
  align-items: center;
  animation: ${({ open }) => (open ? fadeIn : "none")} 0.3s ease;
  li {
    margin: 0;
  }
`;

const StyledIconWrappr = styled.div`
  position: absolute;
  right: 15px;
  color: #999;
  cursor: pointer;
  display: none;

  &:hover {
    color: #dabfa8;
  }

  @media screen and (max-width: 690px) {
    display: block;
  }
`;

export default Header;
